import { useEffect } from "react";
import { StripeConfirmModalHeader } from "./StripeConfirmModalHeader";
import { StripeConfirmModalFormWrapper } from "./StripeConfirmModalFormWrapper";

const StripeConfirmModal = ({
  selectedListingId,
  setSelectedListingId,
  listing,
  getListing,
  openStripeConfirmModal,
  setOpenStripeConfirmModal,
}) => {
  useEffect(() => {
    document.body.classList.add("modal-open");

    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);

  return (
    <>
      <div
        className="modal fade show d-block"
        id="kt_modal_add_user"
        role="dialog"
        tabIndex={-1}
        aria-modal="true"
      >
        {/* begin::Modal dialog */}
        <div className="modal-dialog modal-dialog-centered mw-650px">
          {/* begin::Modal content */}
          <div className="modal-content">
            <StripeConfirmModalHeader
              setSelectedListingId={setSelectedListingId}
              listing={listing}
              setOpenStripeConfirmModal={setOpenStripeConfirmModal}
            />
            {/* begin::Modal body */}
            <div className="modal-body scroll-y mx-5 mx-xl-5 my-2 p-4">
              <StripeConfirmModalFormWrapper
                selectedListingId={selectedListingId}
                setSelectedListingId={setSelectedListingId}
                listing={listing}
                getListing={getListing}
               openStripeConfirmModal={openStripeConfirmModal}
                setOpenStripeConfirmModal={setOpenStripeConfirmModal}
              />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>
      {/* end::Modal Backdrop */}
    </>
  );
};

export { StripeConfirmModal };
